import React from 'react';

const ProjectCard = (props) => {
    const { img, title, category, link, uses } = props.project;
    return (
        <div className="col-sm-4 p-0 gy-5">
            <div className="col-sm-12 p-3 text-white">
                <a href={link} target="_blank" style={{color: 'gray'}}>
                    <div class="card" >
                        <img src={img} height="200px" class="card-img-top" alt="..." />
                        <div class="card-body">
                            <h4 className="my-card-heading">{title}</h4>
                            <p class="card-text my-paragraph">uses: {uses}</p>
                        </div>
                    </div>
                </a>
            </div>
            {/* <div class="card mb-3" style={{maxWidth: '540px'}}>
                <div class="row g-0">
                    <div class="col-md-4">
                        <img width="100px" src={img} alt="..." />
                    </div>
                    <div class="col-md-8">
                        <div class="card-body">
                            <h5 class="card-title">{title}</h5>
                            <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                            <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
                        </div>
                    </div>
                </div>
            </div> */}
        </div>
    );
};

export default ProjectCard;